import createConfigurableObject from '../../../utils/configurationObject';

export default (app) => {
    app.mainLayout = app.mainLayout || createConfigurableObject();
    app.settingsTabs = app.settingsTabs || createConfigurableObject();
};
